import Joi from 'joi';

export const InfoGraphicSchema = Joi.object({
  title: Joi.string().required(),
  pined: Joi.string().required(),
  image: Joi.string().required(),
});
